import { Schema, arrayOf } from 'normalizr';

export const folder = new Schema('folders');
const resource = new Schema('resources');

folder.define({
  resources: arrayOf(resource),
});

export const folders = arrayOf(folder);



// WEBPACK FOOTER //
// ./src/modules/bucket/api/schema.js